<template>
  <div
    v-if="chartData.length > 0"
    class="verified-chart-container-adt"
  >
    <highcharts :options="chartOptions" />
    <div
      v-for="(chart, idx) in chartData"
      :key="idx"
      class="verified-chart-legend"
    >
      <div
        class="legend-color-square"
        :style="{ backgroundColor: colorList[idx] }"
      />
      <div class="legend-condition-group">
        {{ chart.name }} ({{ chart.y }})
      </div>
    </div>
  </div>
  <div
    v-else-if="showNoIssues"
    class="verified-chart-no-issues-container"
  >
    <div class="verified-chart-title">
      Verification Issues
    </div>
    <img
      class="verified-chart-no-issues"
      src="@shared/assets/img/adoption/no-issues-chart.svg"
    >
  </div>
</template>

<script>
import adoptionMixin from '@shared/mixins/adoptionMixin';
import adminMixin from '@shared/mixins/adminMixin';

export default {
  name: 'VerificationPieChart',
  mixins: [adminMixin, adoptionMixin],
  data() {
    return {
      colorList: ['#17244B', '#4C5781', '#939CBC', '#4979FF', '#2759E4'],
      chartData: [],
      showNoIssues: false,
    };
  },
  computed: {
    chartOptions() {
      return {
        credits: {
          enabled: false,
        },
        chart: {
          type: 'pie',
          backgroundColor: '#0B0F1E',
        },
        title: {
          align: 'left',
          text: 'Verification Issues',
          style: {
            color: '#FFFFFF',
            fontWeight: 'bold',
          },
        },
        plotOptions: {
          series: {
            allowPointSelect: false,
            cursor: 'pointer',
          },
        },
        series: [
          {
            borderColor: null,
            name: 'Count',
            colorByPoint: true,
            dataLabels: {
              enabled: false,
            },
            data: this.chartData,
          },
        ],
      };
    },
  },
  watch: {
    selectedCorpId() {
      this.getChartData();
    },
  },
  mounted() {
    if (this.selectedCorpId) {
      this.getChartData();
    }
  },
  methods: {
    async getChartData() {
      const data = await this.$store.dispatch('getFailReasons');
      let sortable = Object.fromEntries(Object.entries(data).sort(([, a], [, b]) => b - a));
      const keys = Object.keys(sortable);
      if (keys.length > 5) {
        let otherTotal = 0;
        const otherObjs = {};
        for (let i = 0; i < keys.length; i++) {
          if (i >= 4) {
            const dataKey = keys[i];
            otherTotal += sortable[dataKey];
            delete sortable[dataKey];
          }
        }
        if (otherTotal > 5) {
          sortable['All Other Issues'] = otherTotal;
        } else {
          const combinedSettings = { ...sortable, ...otherObjs };
          sortable = combinedSettings;
        }
      }
      const chartData = [];
      if (keys.length > 0) {
        Object.keys(sortable).forEach((d, idx) => {
          chartData.push({
            name: d,
            y: sortable[d],
            color: this.colorList[idx],
          });
        });
      }
      if (chartData.length === 0) {
        this.showNoIssues = true;
      }
      this.chartData = chartData;
    },
  },
};
</script>

<style lang="scss">
.verified-chart-container-adt {
  display: flex;
  flex-direction: column;
  margin: 20px;

  .verified-chart-legend {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    .legend-color-square {
      border: 1px solid #8990A2;
      border-radius: 8px;
      width: 29px;
      height: 30px;
      margin-right: 10px;
    }
    .legend-condition-group {
      color: $WHITE;
      font-size: 14px;
      font-weight: bold;
    }
  }
}
.verified-chart-no-issues-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px;
  .verified-chart-title {
    width: 100%;
    font-weight: bold;
    font-size: 20px;
    color: $WHITE;
    text-align: left;
    margin-bottom: 15px;
  }
  .verified-chart-no-issues {
    width: 317px;
    height: 317px;
  }
}
</style>
